<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <div
                    v-if="
                        (isLoading && resultsLength === 0) ||
                        ((!isLoading || isError) && resultsLength === 0)
                    "
                >
                    <QTable
                        :data="[]"
                        :columns="formattedColumns"
                        :hide-bottom="true"
                        :rows-per-page-options="[0]"
                        :loading="isLoading"
                        class="q-table"
                    >
                        <template v-slot:header-cell="props">
                            <q-th :props="props">
                                <input
                                    type="checkbox"
                                    style="cursor: pointer;"
                                    v-if="props.col.name == 'checkbox'"
                                    disabled
                                />
                                <strong v-else class="text-capitalize">{{
                                    props.col.label
                                }}</strong>
                            </q-th>
                        </template>
                        <template v-slot:bottom-row>
                            <q-tr
                                v-if="
                                    resultsLength == 0 && !isLoading && !isError
                                "
                            >
                                <q-td colspan="12">No records available</q-td>
                            </q-tr>
                        </template>
                    </QTable>
                </div>
                <div v-else-if="resultsLength > 0">
                    <div
                        class="w-100"
                        v-for="result in results"
                        :key="result[0]"
                    >
                        <p class="item-name text-capitalize">
                            {{ result.name }}
                        </p>

                        <QTable
                            :data="result.records"
                            :columns="formattedColumns"
                            :hide-bottom="true"
                            :rows-per-page-options="[0]"
                            :loading="isLoading"
                            row-key="recordId"
                            class="q-table"
                        >
                            <template v-slot:header-cell="props">
                                <q-th :props="props">
                                    <input
                                        type="checkbox"
                                        style="cursor: pointer;"
                                        v-if="props.col.name == 'checkbox'"
                                        v-model="result.selected"
                                        @change="resultSelected(result)"
                                    />
                                    <strong v-else class="text-capitalize">{{
                                        props.col.label
                                    }}</strong>
                                </q-th>
                            </template>
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td
                                        v-for="col in props.cols"
                                        :key="col.name"
                                        :props="props"
                                        row-key="name"
                                    >
                                        <input
                                            type="checkbox"
                                            style="cursor: pointer;"
                                            v-if="col.name === 'checkbox'"
                                            v-model="checked"
                                            :value="props.row.recordId"
                                        />
                                        <client-name
                                            v-else-if="
                                                col.name === 'owner' &&
                                                props.row.clientName
                                            "
                                            :use-router="USE_CLIENT_MODULE_VUE"
                                            :client="
                                                generateClientObject(props.row)
                                            "
                                        />
                                        <patient-name
                                            v-else-if="
                                                col.name === 'patient' &&
                                                props.row.patientName
                                            "
                                            :use-router="USE_PATIENT_MODULE_VUE"
                                            :patient="
                                                generatePatientObject(props.row)
                                            "
                                            :show-status="true"
                                        />
                                        <item-name
                                            v-else-if="col.name === 'vaccine'"
                                            :item="{
                                                name: props.row.itemName,
                                                encodedId:
                                                    props.row.item_encoded_id
                                            }"
                                        />
                                        <span v-else> {{ col.value }} </span>
                                    </q-td>
                                </q-tr>
                            </template>
                            <template v-slot:bottom-row>
                                <q-tr
                                    v-if="
                                        result.records.length == 0 &&
                                        !isLoading &&
                                        !isError
                                    "
                                >
                                    <q-td colspan="12"
                                        >No records available</q-td
                                    >
                                </q-tr>
                            </template>
                        </QTable>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import Report from "@/mixins/report.js";
import "@/css/quasar-table.css";
import { QTable } from "quasar";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import ClientName from "@/components/commons/client-name";
import PatientName from "@/components/commons/patient-name";
import { forEach, map } from "lodash";
import ItemName from "@/components/commons/item-name";
export default {
    components: {
        QTable,
        ClientName,
        PatientName,
        ItemName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: true,
            results: [],
            resultsLength: 0,
            title: "Rabies Summary",
            isError: false,
            dateRange: "",
            formattedColumns: [
                {
                    name: "checkbox",
                    label: "",
                    field: "checkbox",
                    align: "left",
                    style: "width:2%"
                },
                {
                    name: "patient",
                    label: "Patient",
                    field: "patient",
                    align: "left",
                    style: "width:10%;max-width:110px"
                },
                {
                    name: "chip",
                    label: "Chip",
                    field: "chip",
                    align: "left",
                    style: "width: 5%",
                    classes: "text-capitalize"
                },
                {
                    name: "owner",
                    label: "Owner",
                    field: "client",
                    align: "left",
                    style: "width:10%;max-width:110px"
                },
                {
                    name: "vaccine",
                    label: "Vaccine",
                    field: "itemName",
                    align: "left",
                    style: "width: 12%"
                },
                {
                    name: "given",
                    label: "Given",
                    field: "given",
                    align: "left",
                    style: "width:9%;max-width:105px"
                },
                {
                    name: "due",
                    label: "Next Due",
                    field: "due",
                    align: "left",
                    style: "width:9%;max-width:105px"
                },
                {
                    name: "route",
                    label: "Route",
                    field: "route",
                    align: "left",
                    format: (val, row) => {
                        return row.route_id == 0 ? "None" : val;
                    },
                    style: "width:8%;max-width:100px"
                },
                {
                    name: "given_by",
                    label: "Given By",
                    field: "serviceProvider",
                    align: "left",
                    classes: "text-capitalize",
                    style: "width:13%;max-width:100px"
                },
                {
                    name: "tag",
                    label: "Tag",
                    field: "tag",
                    align: "left",
                    style: "width:4%;max-width:100px"
                },
                {
                    name: "manufacturer",
                    label: "Manufacturer",
                    field: "manufacturer",
                    align: "left",
                    style: "width: 5%"
                },
                {
                    name: "lotNumber",
                    label: "Lot Number",
                    field: "lotNumber",
                    align: "left",
                    style: "width: 8%",
                    classes: "text-capitalize"
                },
                {
                    name: "expiration",
                    label: "Expiration",
                    field: "expiration",
                    align: "left",
                    style: "width:5%;max-width:105px",
                    classes: "text-capitalize"
                }
            ]
        };
    },
    computed: {
        checked: {
            get() {
                return this.$store.state.report.rabiesSummary.selectedRecordIds;
            },
            set(value) {
                this.$store.commit("report/rabiesSummaryRecordIds", value);
            }
        }
    },
    async mounted() {
        let self = this;
        await self._getSetting();
        self.data.species = [];
        self.data.city = [];
        self.data.reportId = CREPORT.TYPE.RABIES_SUMMARY;
        self.data.start = self.getStartDate("day");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);
        self.data.isShowDateRange = true;
        self.dynamicPageTitle(self.title);
        self.init();
        self.$root.$on("report-filter-date-range:refresh", self.prepareData);
    },
    beforeDestroy: function () {
        this.data.reportId = null;
        this.data.species = [];
        this.data.city = [];
        this.$root.$off("report-filter-date-range:refresh", this.prepareData);
    },
    methods: {
        prepareData(data) {
            if (data) {
                this.data.from = data.from;
                this.data.to = data.to;
                this.data.species = data.species;
                this.data.city = data.city;
            }
            this.init();
        },
        async init() {
            let self = this;
            self.isLoading = true;
            self.isError = false;
            self.results = [];
            self.resultsLength = 0;
            self.checked = [];
            self.dateRange = "";
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            await ReportService.getReport(CREPORT.TYPE.RABIES_SUMMARY, {
                from: self.data.from,
                to: self.data.to,
                city_option:
                    self.data.city && self.data.city.length > 0
                        ? map(self.data.city, "value")
                        : [],
                species_option:
                    self.data.species && self.data.species.length > 0
                        ? map(self.data.species, "value")
                        : []
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.dateRange = self.getDateRange(
                            res.resource.meta.from,
                            res.resource.meta.to
                        );

                        forEach(res.resource.results, (records, species) => {
                            records.forEach(function (record) {
                                record.selected = true;
                                self.checked.push(record.recordId);
                            });
                            let data = {
                                name: species,
                                selected: true,
                                records: records
                            };

                            self.results.push(data);
                        });
                        self.resultsLength = self.results.length;
                        self.isLoading = false;
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    self.isError = true;
                    self.isLoading = false;
                    self._message("Error: Unable to get the report", "danger");
                });
        },
        generateClientObject(row) {
            const isDeleted = this.capitalize(row.clientName).includes(
                "(deleted)"
            );
            return {
                id: isDeleted ? null : row.clientId,
                name: this.capitalize(row.clientName.replace("(deleted)", "")),
                encoded_id: isDeleted ? null : row.client_encoded_id,
                isactive: !isDeleted
            };
        },
        generatePatientObject(row) {
            return {
                name: this.capitalize(row.patientName),
                encodedId: row.patient_encoded_id,
                isactive: true
            };
        },
        resultSelected(result) {
            let self = this;

            const recordIds = result.records.map(record => record.recordId);
            if (result.selected) {
                self.checked = [...self.checked, ...recordIds];
            } else {
                self.checked = self.checked.filter(value => {
                    return !recordIds.includes(value);
                });
            }
        }
    }
};
</script>
